<template>
  <div class="content_detail">
    <div class="title">
      <h1>Detalle de alianza</h1>
      <!-- <div class="category">
        <h3>Categoría: </h3><span>{{ category_name }}</span>
      </div> -->
    </div>
    <hr class="separador">

    <!-- Desktop, Tablet y Mobile -->
    <div class="container_alliance_detail">
      <div class="alliance_deatil" v-for="alliance in allianceDetail" :key="alliance.id">
        <img 
          @click="irRedirection(alliance.redirection)"
          :title="alliance.name" 
          class="image_alliance" 
          :src="alliance.url"
          alt="Detalle de alianza"
        >
        <img 
          v-if="alliance.redirection_whatsapp != null"
          id="icon_wp" 
          src="../../assets/img/Contacta-aquí.png" 
          @click="irRedirection(alliance.redirection_whatsapp)"
          alt="WhatsApp"
        >
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
// import $ from "jquery";

export default {
  name: "alliances",
  props: {
    alliance: Object,
    name: String
  },
  data(){
    return {
      alliances: [],
      allianceDetail: [],
    }
  },
  methods: {
    irRedirection(url, redirection_whatsapp) {
      if (url != null) {
        var a = document.createElement('a');
        a.target="_blank";
        a.href=url;
        a.click();
      }
      if (redirection_whatsapp != null) {
        var b = document.createElement('b');
        b.target="_blank";
        b.href=redirection_whatsapp;
        b.click();
      }
    },
    getAllianceById(name){
      if (name.includes("-")){
        name = name.replace(/-/g, " ");
      }
      axios
        .get(`api/file/allianceById/${name}`)
        .then(res =>{
          this.alliances = [];
          this.allianceDetail = [];
          this.alliances = res.data.data;
          this.alliances.forEach(element => {
            if(element.size == 5){
              this.allianceDetail.push(element);
            }
          });
          // console.log(JSON.stringify(this.alliances));
        })
    },
  },
  mounted(){
    const currentUrl = window.location.href;
    const myArray = currentUrl.split("allianceDetail/");
    const name = decodeURI(myArray[1]);
    this.getAllianceById(name);
    const url_sin_espacios = name.replace(/ /g, "-");
    history.replaceState(null, null, url_sin_espacios);
  }
}
</script>

<style scoped>
.content_detail{
  padding-top: 80px;
  padding-bottom: 30px;
  background-color: #eaeaea;
}
.title{
  margin: auto;
}
.title h1{
  color: #dc3545;
  font-weight: bold;
}
.category{
  display: flex;
  justify-content: center;
  align-items: center;
}
.category h3{
  color: black;
  font-weight: bold;
  padding: 5px 10px 5px 5px;
}
.category span{
  color: #dc3545;
  font-size: 18px;
  margin-bottom: 5px;
}
.separador{
  max-width: 90%;
  margin: 0px auto 25px auto;
  background-color: #dc3545;
  padding: 1px;
}
.container_alliance_detail{
  max-width: 90%;
  margin: auto;
}
.alliance_deatil{
  padding: 5px;
  border-radius: 5px;
  cursor: pointer;
}
.image_alliance{
  width: 100%;
  height: auto;
  border-radius: 5px;
}
#icon_wp{
  cursor: pointer;
  position: sticky;
  z-index: 100 !important;
  width: 250px;
}

@media (max-width: 990px){
  #icon_wp{
    width: 200px !important;
  }
}
@media (max-width: 780px){
  .title h1{
    font-size: 32px;
  }
  #icon_wp{
    width: 150px !important;
  }
}
@media (max-width: 480px){
  .title h1{
    font-size: 24px;
  }
  #icon_wp{
    width: 100px !important;
  }
}
</style>